//Controller names
const ACCOUNTS = "/accounts";
const CONTENTS = "/contents";
const PARTS = "/parts";
const VEHICLES = "/vehicles";
const NOTES = "/notes";
const FINANCES = "/finances";
const OLX = "/olx";

// Olx
export const PUBLISH = OLX;
// Finances
export const GET_FINANCES = FINANCES;
export const GET_TODAY_FINANCES = FINANCES + "/today";
export const GET_GENERAL_FINANCES = FINANCES + "/general";

// Finance Reports
export const GET_DAILY_REPORT = FINANCES + "/report/daily";
export const GET_WEEKLY_REPORT = FINANCES + "/report/weekly";
export const GET_MONTHLY_REPORT = FINANCES + "/report/monthly";
export const GET_YEARLY_REPORT = FINANCES + "/report/yearly";
export const GET_SALES_DETAILS = FINANCES + "/sales";

// Accounts
export const REGISTER = ACCOUNTS + "/register";
export const LOGIN = ACCOUNTS + "/login";

// Parts
export const GET_PARTS = PARTS + "/page";
export const GET_PART = PARTS;
export const ADD_PART = PARTS;
export const UPDATE_PART = PARTS;

export const PART_IMAGE = (partId, imageId) => `${PARTS}/${partId}/images/${imageId}`;
export const PART_IMAGE_FEATURE = (partId, imageId) => `${PARTS}/${partId}/images/${imageId}/feature`;

export const ADD_NEW_PART_IMAGES   = (partId) => `${PARTS}/${partId}/add-images`;
export const DELETE_PART_IMAGE = (partId, imageId) =>
  `${PARTS}/${partId}/images/${imageId}`;

// Vehicles
export const GET_ROWS = VEHICLES + "/rows";
export const GET_VEHICLES = VEHICLES + "/page";
export const GET_VEHICLE = VEHICLES;
export const ADD_VEHICLE = VEHICLES;
export const UPDATE_VEHICLE = VEHICLES;

export const ADD_PART_IMAGES = PARTS + "/add-images";
export const PUBLISH_PART = PARTS + "/publish-part";

export const ADD_VEHICLE_IMAGES = VEHICLES + "/add-images";
export const PUBLISH_VEHICLE = VEHICLES + "/publish";

// Notes
export const GET_NOTES = NOTES + "/page";
export const ADD_NOTE = NOTES;
export const UPDATE_NOTE = NOTES;
export const ADD_DELIVERY = NOTES + "/delivery";
export const GET_DELIVERY = (noteId) => `${NOTES}/delivery/${noteId}`;
export const UPDATE_DELIVERY = (noteId) => `${NOTES}/delivery/${noteId}`;